import showdown from 'showdown'

const converter = new showdown.Converter({ tables: true, strikethrough: true, simplifiedAutoLink: false })
const allowed = new Set(['P', 'BR', 'STRONG', 'EM', 'DEL', 'UL', 'OL', 'LI', 'BLOCKQUOTE', 'PRE', 'CODE', 'TABLE', 'THEAD', 'TBODY', 'TR', 'TH', 'TD', 'HR', 'H1', 'H2', 'H3', 'H4', 'A'])
export function safeHref(raw) {
  if (!raw) return null
  if (/^\/(?!\/)/.test(raw) && !/[\\\u0000-\u0020]/.test(raw)) return raw
  try { const url = new URL(raw); return url.protocol === 'https:' || url.protocol === 'http:' ? url.href : null } catch (_) { return null }
}
export function renderMarkdown(text) {
  // Raw HTML is always displayed as text; sanitize generated markup and all attributes as well.
  const escaped = String(text || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
  const doc = new DOMParser().parseFromString(converter.makeHtml(escaped), 'text/html')
  Array.from(doc.body.querySelectorAll('*')).forEach(el => {
    if (!allowed.has(el.tagName)) { el.replaceWith(doc.createTextNode(el.textContent || '')); return }
    const href = el.tagName === 'A' ? safeHref(el.getAttribute('href')) : null
    Array.from(el.attributes).forEach(attr => el.removeAttribute(attr.name))
    if (href) { el.setAttribute('href', href); if (!href.startsWith('/')) { el.setAttribute('rel', 'noopener noreferrer'); el.setAttribute('target', '_blank') } }
  })
  return doc.body.innerHTML
}
